import { useMemo } from "react";

export function useSwiperPagination() {
  return useMemo(
    () => ({
      clickable: true,
      renderBullet: (_index: number, className: string) =>
        `<span class="${className}"></span>`,
    }),
    []
  );
}
